
define('template!adminWorkActivityDetailPopupTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="admin-work-activity-detail-popup">\n  <header class="popup-header">\n    <div class="user-cell">\n      <span class="user-avatar">' +
__e( initials ) +
'</span>\n      <div class="user-meta">\n        <span class="user-name">' +
__e( fullName ) +
'</span>\n        ';
 if (handle) { ;
__p += '\n          <span class="user-handle">' +
__e( handle ) +
'</span>\n        ';
 } ;
__p += '\n      </div>\n    </div>\n    <div class="range">\n      <i class="fa fa-calendar"></i>\n      ' +
__e( rangeLabel ) +
'\n    </div>\n  </header>\n\n  ';
 if (loading) { ;
__p += '\n    <div class="detail-loading">' +
((__t = ( _.i18n('common.loading', null, 'Loading…') )) == null ? '' : __t) +
'</div>\n  ';
 } else { ;
__p += '\n    <section class="kpi-row">\n      <div class="kpi">\n        <div class="kpi-value">' +
__e( totalHours ) +
'</div>\n        <div class="kpi-label">' +
((__t = ( _.i18n('admin.workActivity.detail.tracked', null, 'Tracked') )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="kpi">\n        <div class="kpi-value">' +
__e( totalDays ) +
'</div>\n        <div class="kpi-label">' +
((__t = ( _.i18n('admin.workActivity.activeDays', null, 'Active days') )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="kpi">\n        <div class="kpi-value">' +
__e( totalMoves ) +
'</div>\n        <div class="kpi-label">' +
((__t = ( _.i18n('admin.workActivity.detail.moves', null, 'Moves') )) == null ? '' : __t) +
'</div>\n      </div>\n    </section>\n\n    <section class="detail-body">\n      <div class="detail-col">\n        <h4>' +
((__t = ( _.i18n('admin.workActivity.detail.dailyHours', null, 'Daily hours') )) == null ? '' : __t) +
'</h4>\n        ';
 if (daily.length === 0) { ;
__p += '\n          <div class="empty">' +
((__t = ( _.i18n('admin.workActivity.noData', null, 'No data for this period') )) == null ? '' : __t) +
'</div>\n        ';
 } else { ;
__p += '\n          <div class="detail-chart">\n            <canvas class="js-daily-chart"></canvas>\n          </div>\n          <table class="mini-table daily-table">\n            <thead>\n              <tr>\n                <th>' +
((__t = ( _.i18n('admin.workActivity.day', null, 'Day') )) == null ? '' : __t) +
'</th>\n                <th class="num">' +
((__t = ( _.i18n('admin.workActivity.hours', null, 'Hours') )) == null ? '' : __t) +
'</th>\n                <th>' +
((__t = ( _.i18n('admin.workActivity.firstSeen', null, 'First seen') )) == null ? '' : __t) +
'</th>\n                <th>' +
((__t = ( _.i18n('admin.workActivity.lastSeen', null, 'Last seen') )) == null ? '' : __t) +
'</th>\n              </tr>\n            </thead>\n            <tbody>\n              ';
 _.each(daily, function (d) { ;
__p += '\n                <tr>\n                  <td>' +
__e( d.dayLabel ) +
'</td>\n                  <td class="num"><strong>' +
__e( d.hours ) +
'</strong></td>\n                  <td>' +
__e( d.firstSeenLabel ) +
'</td>\n                  <td>' +
__e( d.lastSeenLabel ) +
'</td>\n                </tr>\n              ';
 }); ;
__p += '\n            </tbody>\n          </table>\n        ';
 } ;
__p += '\n      </div>\n\n      <div class="detail-col">\n        <h4>' +
((__t = ( _.i18n('admin.workActivity.detail.statusChanges', null, 'Status changes') )) == null ? '' : __t) +
'</h4>\n        ';
 if (changeGroups.length === 0) { ;
__p += '\n          <div class="empty">' +
((__t = ( _.i18n('admin.workActivity.noActivity', null, 'No activity') )) == null ? '' : __t) +
'</div>\n        ';
 } else { ;
__p += '\n          ';
 _.each(changeGroups, function (group) { ;
__p += '\n            <div class="changes-group">\n              <div class="changes-group-title">\n                <span class="badge cmd">' +
__e( group.commandType ) +
'</span>\n                <span class="changes-group-total">' +
__e( group.total ) +
'</span>\n              </div>\n              <table class="mini-table">\n                <tbody>\n                  ';
 _.each(group.items, function (item) { ;
__p += '\n                    <tr>\n                      <td><span class="status-pill">' +
__e( item.status ) +
'</span></td>\n                      <td class="num"><strong>' +
__e( item.count ) +
'</strong></td>\n                    </tr>\n                  ';
 }); ;
__p += '\n                </tbody>\n              </table>\n            </div>\n          ';
 }); ;
__p += '\n        ';
 } ;
__p += '\n      </div>\n    </section>\n  ';
 } ;
__p += '\n\n  <footer class="popup-footer">\n    <button type="button" class="btn btn-default js-close">' +
((__t = ( _.i18n('common.close', null, 'Close') )) == null ? '' : __t) +
'</button>\n  </footer>\n</div>\n';

}
return __p
};});

